import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { DirectionIndicator } from './SortingDirection';
import { switchDirection } from './Table.helpers';

import {
  SortingDirection,
  ContentPosition,
  ContentPositionClassNames,
} from './constants';

export interface TableHeadCell {
  id: number | string;
  title?: string;
  tableHeadCellClass?: string;
  titleRenderer?: (props?: TableHeadCell) => JSX.Element;
  isSortingAvailable?: boolean;
  width?: string;
  startingDirection?: SortingDirection;
  directionSetter?: SortingDirection;
  sortingChanged?: (direction: SortingDirection) => void;
  contentPosition?: ContentPosition;
  isColumnHidden?: boolean;
}

export const HeadCell: React.FC<TableHeadCell> = (props) => {
  const {
    title,
    tableHeadCellClass = '',
    titleRenderer,
    isSortingAvailable,
    startingDirection,
    directionSetter,
    sortingChanged,
    contentPosition,
  } = props;

  const [direction, setDirection] = useState<SortingDirection>(
    startingDirection || SortingDirection.NONE
  );

  const clickHandler = () => {
    if (isSortingAvailable) {
      const newDirection = switchDirection(direction);

      setDirection(newDirection);

      if (sortingChanged) {
        sortingChanged(newDirection);
      }
    }
  };

  const headCellWrapperAttr: React.HTMLAttributes<HTMLDivElement> = {
    className: classNames(
      'ui-table-head-cell',
      ContentPositionClassNames[contentPosition || ContentPosition.LEFT],
      tableHeadCellClass,
      { 'ui-table-head-cell--clickable': isSortingAvailable }
    ),
    onClick: clickHandler,
    onKeyDown: clickHandler,
  };

  if (isSortingAvailable) {
    headCellWrapperAttr.role = 'button';
  }

  useEffect(() => {
    if (directionSetter) {
      setDirection(directionSetter);
    }
  }, [directionSetter]);

  if (titleRenderer) {
    return titleRenderer(props);
  }

  return (
    <div {...headCellWrapperAttr}>
      <div className="link-small-semibold">{title || ''}</div>
      {isSortingAvailable && (
        <div className="ui-table-sorting-direction">
          <DirectionIndicator direction={direction} />
        </div>
      )}
    </div>
  );
};
